import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

interface IProps {
  width?: number;
  height?: number;
  className?: string;
  src?: string;
}

function AffirmLogo(props: IProps) {
  const {
    width, height, className = "", src,
  } = props;
  const altText = "Pay With Affirm";
  return (
    <PAImage
      unoptimized
      width={width || 50}
      height={height || 16}
      src={src || getRelativeImagePath("/cms/pubicImages/images/AffirmFinance.webp")}
      alt={altText}
      title={altText}
      className={className}
    />
  );
}

export default AffirmLogo;
